import { useLocation } from 'react-router-dom'
import { AppContentLoader, LoaderSwitcher } from 'router/loaders'
import { Landing } from '../../shop/pages'

interface LandingProps {
  onClose: () => void
}

export const LandingWrapper = (props: LandingProps) => {
  const location = useLocation()
  const landingView = location.pathname.includes('browse')
    ? 'browse'
    : undefined

  return (
    <AppContentLoader>
      {(isParentLoaded) => (
        <LoaderSwitcher isParentLoaded={isParentLoaded}>
          <Landing {...props} view={landingView} />
        </LoaderSwitcher>
      )}
    </AppContentLoader>
  )
}
